import { render, staticRenderFns } from "./DriversList.vue?vue&type=template&id=06a958de&scoped=true"
import script from "./DriversList.vue?vue&type=script&lang=js"
export * from "./DriversList.vue?vue&type=script&lang=js"
import style0 from "./DriversList.vue?vue&type=style&index=0&id=06a958de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06a958de",
  null
  
)

export default component.exports